import { get } from './request';

export enum BondInsuranceInvoiceStatusEnum {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  CANCELED = 'CANCELED'
}

export type BondInsuranceInvoiceFiltersDTO = {
  insurerId?: string;
  estateId?: string;
  estateUnitId?: string;
  accountManager?: string;
  franchiseId?: string;
  status?: string;
  start?: string;
  end?: string;
  page?: number;
  isRv?: boolean;
};

export type BondInsuranceInvoiceDTO = {
  id: string;
  insurerId: string;
  estateId: string;
  estateUnitId?: string | null;
  amount: number | string;
  dueDate: string;
  paymentDate?: string | null;
  status: BondInsuranceInvoiceStatusEnum;
  invoiceNumber?: string | null;
  billetNumber?: string | null;
  digitableLine?: string | null;
  barcode?: string | null;
  externalId?: string | null;
  externalSource?: string | null;
  createdAt?: string;
  updatedAt?: string;
  insurer?: {
    id: string;
    name: string;
    code?: string;
  };
  estate?: {
    id: string;
    name: string;
    franchiseId?: string;
    user?: {
      id: string;
      name: string;
    };
  };
  estateUnit?: {
    id: string;
    name: string;
  };
};

export type BondInsuranceInvoiceListResponse = {
  data: BondInsuranceInvoiceDTO[];
  quantity: number;
};

export type BondInsuranceInvoiceDetailDTO = {
  id: string;
  invoiceId: string;
  bondInsuranceId?: string | null;
  bondInsuranceHiredDataId?: string | null;
  insurerPolicyId?: string | null;
  policyNumber?: string | null;
  tenantName?: string | null;
  tenantDocument?: string | null;
  address?: string | null;
  product?: string | null;
  installmentNumber?: number | null;
  installmentsAmount?: number | null;
  installmentValue: number | string;
  chargedAmount?: number | string | null;
  description?: string | null;
  externalId?: string | null;
  createdAt?: string;
  updatedAt?: string;
  bondInsurance?: {
    id: string;
  };
  bondInsuranceHiredData?: {
    id: string;
  };
};

export type BondInsuranceInvoiceFileLinkDTO = {
  link: string;
  key: string;
  id?: string;
  name?: string;
  label?: string | null;
  createdAt?: string;
};

export type BondInsuranceInvoiceFilesResponse = {
  success: boolean;
  urls?: BondInsuranceInvoiceFileLinkDTO[];
  msg?: string;
};

const buildQueryString = (filter: BondInsuranceInvoiceFiltersDTO) => {
  const params = new URLSearchParams();

  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value));
    }
  });

  return params.toString();
};

export const listBondInsuranceInvoices = async (
  filter: BondInsuranceInvoiceFiltersDTO
): Promise<BondInsuranceInvoiceListResponse> => {
  const query = buildQueryString(filter || {});
  const [data, quantity] = await get(`/bond-insurance-invoices?${query}`);

  return {
    data: data || [],
    quantity: quantity || 0
  };
};

export const getBondInsuranceInvoiceDetails = async (
  invoiceId: string
): Promise<BondInsuranceInvoiceDetailDTO[]> => {
  return get(`/bond-insurance-invoices/${invoiceId}/details`);
};

export const getBondInsuranceInvoiceBillet = async (
  invoiceId: string
): Promise<BondInsuranceInvoiceFilesResponse> => {
  return get(`/bond-insurance-invoices/${invoiceId}/billet`);
};

export const getBondInsuranceInvoiceAttachments = async (
  invoiceId: string
): Promise<BondInsuranceInvoiceFilesResponse> => {
  return get(`/bond-insurance-invoices/${invoiceId}/attachments`);
};
